module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/images/main_card_background_with_quests.35363bdd.jpg";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/images/main_card_background_with_quests.jpg
// module id = 3015
// module chunks = 11